const SORT_OPTIONS = [
  "cheap",
  "expensive",
  "popular",
  "new",
  "alphabet",
  "-alphabet",
];

export function buildCatalogLink(categorySlug, sort = "new") {
  if (!categorySlug) {
    return "/catalog/";
  }

  const params = new URLSearchParams({
    categories: categorySlug,
    sort: sort || "new",
  });

  return `/catalog/?${params.toString()}`;
}

export function validateShowcaseTabs(tabs) {
  const tabErrors = {};
  const messages = [];

  if (!Array.isArray(tabs)) {
    return {
      valid: false,
      tabErrors: {},
      messages: ["Некорректный список вкладок."],
    };
  }

  tabs.forEach((tab, index) => {
    const errors = {};
    const title = String(tab?.title || "").trim();
    const type = tab?.type === "category" ? "category" : "custom";
    const tabLabel = title || `Вкладка ${index + 1}`;

    if (!title) {
      errors.title = "Укажите название вкладки.";
    }

    if (type === "category" && !String(tab?.category_slug || "").trim()) {
      errors.category_slug = "Выберите категорию.";
    }

    if (type === "category") {
      const sort = String(tab?.sort || "").trim();
      if (sort && !SORT_OPTIONS.includes(sort)) {
        errors.sort = "Выберите корректную сортировку.";
      }
    }

    if (Object.keys(errors).length > 0) {
      tabErrors[index] = errors;
      Object.values(errors).forEach((message) => {
        messages.push(`${tabLabel}: ${message}`);
      });
    }
  });

  return {
    valid: Object.keys(tabErrors).length === 0,
    tabErrors,
    messages,
  };
}

export function buildShowcasePayload(form) {
  const tabs = Array.isArray(form?.tabs) ? form.tabs : [];

  return {
    tabs: tabs.map((tab, index) => {
      const base = {
        id: tab.id || `tab-${index + 1}`,
        type: tab.type === "category" ? "category" : "custom",
        title: String(tab.title || "").trim(),
        visible: tab.visible !== false,
        button_text:
          (tab.button_text || "ПОКАЗАТЬ БОЛЬШЕ").trim() || "ПОКАЗАТЬ БОЛЬШЕ",
        button_link: (tab.button_link || "/catalog/").trim() || "/catalog/",
      };

      if (base.type === "category") {
        return {
          ...base,
          category_slug: tab.category_slug || "",
          sort: tab.sort || "new",
        };
      }

      return {
        ...base,
        product_ids: (tab.productRows || []).map((row) => Number(row.product.id)),
      };
    }),
  };
}

export function parseShowcaseApiErrors(error) {
  const response = error?.response;
  const data = response?.data;

  if (response?.status === 422 && data?.errors) {
    return {
      messages: Object.values(data.errors).flat(),
      tabErrors: mapApiErrorsToTabs(data.errors),
    };
  }

  if (typeof data?.message === "string" && data.message.trim()) {
    return {
      messages: [data.message],
      tabErrors: {},
    };
  }

  return {
    messages: ["Не удалось сохранить настройки. Попробуйте ещё раз."],
    tabErrors: {},
  };
}

function mapApiErrorsToTabs(errors) {
  const tabErrors = {};

  Object.entries(errors).forEach(([key, value]) => {
    const match = key.match(/^tabs\.(\d+)\.(.+)$/);
    if (!match) {
      return;
    }

    const index = Number(match[1]);
    const field = match[2];
    const message = Array.isArray(value) ? value[0] : value;

    if (!tabErrors[index]) {
      tabErrors[index] = {};
    }

    tabErrors[index][field] = message;
  });

  return tabErrors;
}
